/**
 * Frontend-side demo mocks.
 *
 * Only the two endpoints that have no storeId in the URL are mocked here —
 * the backend `demoStoreGate` middleware can't intercept those since it keys
 * on `:storeId`. Every store-scoped request (widgets, orders, products,
 * customers, wallet, analytics, …) goes to the real API, where the
 * middleware serves static JSON fixtures from `code/routes/api/v1/middleware/demoMocks/`
 * and blocks writes.
 */

import { DEMO_STORE_ID } from './demoMode';

const demoStore = {
  _id: 'demo-store-id',
  id: DEMO_STORE_ID,
  name: 'متجر التجربة',
  logo: null as string | null,
  domain: 'demo.00stores.com',
  currency: 'SAR',
  role: 'owner',
  permissions: ['all'],
  accepted: true,
};

const demoUser = {
  userId: 'demo-user-id',
  email: 'demo@zero.00team.com',
  username: 'demo',
  admin: false,
  verifiedIdentity: true,
  realName: 'مستخدم التجربة',
};

export const demoFixtures = {
  user: demoUser,
  store: demoStore,
  stores: [demoStore],
};

export function resolveDemoResponse(method: string, url: string): unknown | undefined {
  const m = method.toUpperCase();
  const path = url.replace(/^\/api\/v1/, '').replace(/\?.*$/, '');

  if (m === 'GET' && path === '/dashboard/auth/me') return demoUser;
  if (m === 'GET' && path === '/dashboard/stores')  return { stores: [demoStore], pendingInvitations: [] };

  return undefined;
}
